<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ 'RIDP_SERVICEDOWN_HEADER' | globalTranslate }}</h1>
  </div>
  <div class="modal-body text-center">
    <div class="pt-3 pb-2">
      <p class="mb-0">{{ 'RIDP_SERVICEDOWN_TEXT' | globalTranslate }}</p>
    </div>
    <div class="modal-footer justify-content-center">
      <div class="me-2 ml-2">
        <button type="button" id="dialog" class="btn d-grid btn-secondary" (click)="onContinue()">{{ 'RIDP_RETURN_BUTTON' | globalTranslate }}</button>
      </div>
    </div>
  </div>